import { gql } from "@/__generated__/gql";

export const COMMIT_SCORE_TIME_SERIES = gql(`
  query commitScoreTimeSeries($orgId: ID!, $userId: ID!) {
    node(id: $userId) {
      id
      ... on Student {
        commitScoreTimeSeries(organizationId: $orgId) {
          date
          value
          index
        }
      }
    }
  }
`);
